<script>
import Badge from '@/components/Badge'
import { ToArray } from '@/utils'

export default {
  props: {
    value: Array,
  },
  computed: {
    presets() {
      return [
        { prefix: 'finn', image: '/api/integration/preset/finn/assets/favicon.png', label: 'Finn' },
        { prefix: 'import', icon: 'fa-pro-light:file-import', label: this.$t('imported') },
        { prefix: 'marketing', icon: 'fa-pro-duotone:bullseye-pointer', label: this.$t('addon:ads') },
        { prefix: 'facebook', icon: 'fa-pro-brands:meta', label: 'Meta' },
        {
          prefix: ['core', 'webtop', 'vitec', 'webmegler'],
          icon: 'fa-pro-light:puzzle-piece',
          label: this.$t('integration-category:brokerage'),
        },
      ]
    },
    items() {
      return [...new Set(this.value)].map(v => {
        const preset = this.presets.find(p => ToArray(p.prefix).some(r => new RegExp(`^${r}:?`).test(v)))
        if (!preset) return { label: v }

        return { label: v, ...preset }
      })
    },
  },
  components: {
    Badge,
  },
}
</script>

<template>
  <div class="lead-referrers">
    <Badge v-for="item in items" :icon="item.icon">
      <template #default>{{ item.label }}</template>
      <template v-if="item.image" #icon>
        <img :src="item.image" :alt="item.label" class="badge__icon" />
      </template>
    </Badge>
    <slot v-if="!items.length" name="fallback"></slot>
  </div>
</template>

<style lang="scss">
.lead-referrers {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 3px;

  .badge {
    background-color: transparent;
    border: 1px solid var(--vue-elder-default-border, rgba(0, 0, 0, 0.1));
    color: inherit;
  }

  .badge__icon {
    height: 1.5em;
  }
}
</style>
